import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { PipesModule } from '@app/core/pipes/pipes.module';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { DeviceOrientationEnum, ScreenService } from '@core/services';
import { BillingApiChargePayCheckResponseDto } from '@lingo2-billing-sdk/models';
import { ChangableComponent } from '@models/changable.component';

import { CSchool } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnUiCoverModule } from 'onclass-ui';

export interface BillingOrder {
  id: string;
  currencyCode: string;
  amountToPay: string;
  amount: string;
  taxAmount?: string;
  approximateAmountToPay?: string;
  approximateCurrencyCode?: string;
}

@Component({
  selector: 'app-payment-order',
  templateUrl: './payment-order.component.html',
  styleUrls: ['./payment-order.component.scss'],
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, OnUiCoverModule, PipesModule],
})
export class PaymentOrderComponent extends ChangableComponent {
  // DI
  protected screenService = inject(ScreenService);
  public deviceService = inject(DeviceDetectorService);

  @Input() public set payment(payment: BillingApiChargePayCheckResponseDto) {
    this._payment = payment;
    this.prepareOrder();
  }

  public get payment() {
    return this._payment;
  }

  public _school: CSchool;
  public order: BillingOrder;
  public _payment: BillingApiChargePayCheckResponseDto;

  public prepareOrder() {
    const order = this.payment.order;
    this.order = {
      id: order.id,
      currencyCode: this.payment.currencyCode,
      taxAmount: this.payment.feeAmount,
      amount: this.payment.amount,
      amountToPay: this.payment.amountToPay,
      approximateAmountToPay: this.payment.approximateAmountToPay || null,
      approximateCurrencyCode: this.payment.approximateCurrencyCode || null,
    };
  }

  public screenClasses() {
    const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
    return {
      tablet: this.deviceService.isTablet(),
      mobile: this.deviceService.isMobile(),
      desktop: (!this.deviceService.isTablet() && !this.deviceService.isMobile()) || this.deviceService.isDesktop(),
      portrait: !this.deviceService.isDesktop() && isPortrait,
      landscape: !this.deviceService.isDesktop() && !isPortrait,
    };
  }

  public get title() {
    return 'profile-form.card.title';
  }
}
